import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=b2b22b66&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=b2b22b66&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b22b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b22b66')) {
      api.createRecord('b2b22b66', component.options)
    } else {
      api.reload('b2b22b66', component.options)
    }
    module.hot.accept("./forgetPassword.vue?vue&type=template&id=b2b22b66&scoped=true", function () {
      api.rerender('b2b22b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsConfig/components/forgetPassword.vue"
export default component.exports